import { useState, useCallback } from 'react';

type ApiFunction<TResult> = () => Promise<TResult>;

const useParemeterLessApi = () => {
  const [parameterlessapiloading, setLoading] = useState(false);
  const [parameterlessapierror, setError] = useState<string | null>(null);

   const parameterlessexecuteApi = useCallback(async <TResult>(
    apiFunction: ApiFunction<TResult>
  ): Promise<TResult | null> => {
    setLoading(true);
    setError(null);

    const result = await apiFunction();
    setLoading(false);
      return result;
    }, []);
  

    return { parameterlessapiloading, parameterlessapierror, parameterlessexecuteApi };
};

export default useParemeterLessApi;
